module.exports = __webpack_public_path__ + "images/credit-card-c4f244362797d2f93ef58d8e4c752996.png";